export default {
  setDate(state, date) {
    state.date = date;
  },
  setTransactionStoreNo(state, storeNo) {
    state.transaction.storeNo = storeNo;
  },
  setTransactionPeriod(state, period) {
    state.transaction.periodCondition = period;
  },
  setTransactionData(state, data) {
    state.transaction.data = data;
  },
  setClassifyStoreNo(state, storeNo) {
    state.classify.storeNo = storeNo;
  },
  setClassifyResult(state, data) {
    state.classify.data = data;
  },

  setCountAndSalesStoreNo(state, storeNo) {
    state.countAndSales.storeNo = storeNo;
  },
  setCountAndSalesOrderCondition(state, condition) {
    state.countAndSales.orderCondition = condition;
  },
  setCountPeriodCondition(state, condition) {
    state.countAndSales.countPeriodCondition = condition;
  },
  setSalesPeriodCondition(state, condition) {
    state.countAndSales.salesPeriodCondition = condition;
  },
  setSalesData(state, data) {
    state.countAndSales.salesData = data;
  },
  setCountData(state, data) {
    state.countAndSales.countData = data;
  }
};
